import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as componentTypes from "../../../../constants/componentTypes";
import * as settings from "../../../../constants/settings";
import * as config from "../../../../constants/config";
import * as keyCodes from "../../../../constants/keyCodes";
import * as navigationActions from "../../../../actions/navigationActions";
import * as formulaActions from "../../../../actions/formulaActions";
import * as customTabActions from "../../../../actions/customTabActions";
import * as validationHelper from "../../../../helpers/validationHelper";
import * as formatHelper from "../../../../helpers/formatHelper";
import * as conversionHelper from "../../../../helpers/conversionHelper";
import * as modelHelper from "../../../../helpers/modelHelper";
import * as colorHelper from "../../../../helpers/colorHelper";
import * as tooltipHelper from "../../../../helpers/tooltipHelper";
import * as translationHelper from "../../../../helpers/translationHelper";

import Modal from "../../../global/generic/Modal";
import CancelButton from "../../../global/generic/CancelButton";
import Button from "../../../global/generic/Button";
import Input from "../../../global/generic/Input";
import ColorantBoxes from "../../../global/modal/quickTint/ColorantBoxes";
import NumericKeyboardInput from "../../../global/NumericKeyboardInput";
import CompareColorsSquare from "../tab/matchingTab/matchingOptions/CompareColorsSquare";

import imgConfirm from "../../../../resources/img/svgicons/confirm.svg";
import imgDelete from "../../../../resources/img/svgicons/delete.svg";
import imgWarning from "../../../../resources/img/svgicons/warning-outline.svg";
import imgLoader from "../../../../resources/img/loader.svg";
import imgPlus from "../../../../resources/img/svgicons/plus.svg";

class EditColorantsModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedColorants: [],
            selectedColorantsForScaling: [],
            originalAmounts: null,
            modified: false,
            scaling: 1,
            selectedUnit: this.props.lastUsedUnit === settings.UNIT_MANUAL ? settings.UNIT_ML : this.props.lastUsedUnit,
            activeColorantRow: 0,
            activeColorantAmount: "0",
            originalActiveColorantAmount: "0",
            localData: false,
            originalPreview: null,
            originalColorPreview: config.DEFAULT_RGB,
            colorPreview: config.DEFAULT_RGB,
            manualCorrection: false
        };
    }

    componentDidMount() {
        if (this.props.base !== null && this.props.product !== null) {
            this.props.dispatchGetAllColorantsForBipAction(this.props.tabId, this.props.base.id, this.props.product.id);
        }

        if (this.props.params !== null && this.props.params.formula !== null) {
            let selectedColorants = [];
            let originalAmounts = {};

            let colorant = null;
            for (colorant of this.getColorantsBySelectedUnit()) {
                selectedColorants.push(colorant.clone());
                originalAmounts[colorant.name] = colorant.amount;
            }

            this.setState({
                selectedColorants: selectedColorants,
                selectedColorantsForScaling: selectedColorants,
                originalAmounts: originalAmounts,
                modified: this.props.params.formula.modified,
                scaling: this.props.params.formula.scaling,
                activeColorantRow:
                    this.props.params.formula.scaling === 1 && selectedColorants.length > 0
                        ? selectedColorants[0].id
                        : 0,
                localData: this.props.params.formula.color.local,
                originalPreview: this.props.color === null ? null : this.props.color.rgb,
                originalColorPreview: this.props.params.formula.color.rgb,
                colorPreview: this.props.params.formula.color.rgb,
                manualCorrection: this.props.params.formula.isCorrection()
            });
        }
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (this.state.scaling === 1) {
            if (
                this.state.selectedColorants.length > 0 &&
                prevState.selectedColorants.length !== this.state.selectedColorants.length
            ) {
                let colorantId;

                if (prevState.selectedColorants.length === 0) {
                    colorantId = this.state.selectedColorants[0].id;
                } else {
                    colorantId = this.state.selectedColorants[this.state.selectedColorants.length - 1].id;
                }

                if (window.jQuery("#edit-colorant-" + colorantId).length) {
                    window.jQuery("#edit-colorant-" + colorantId).focus();
                }
            }

            if (prevState.activeColorantRow !== this.state.activeColorantRow) {
                if (window.jQuery("#edit-colorant-" + this.state.activeColorantRow).length) {
                    window.jQuery("#edit-colorant-" + this.state.activeColorantRow).select();
                }
            }
        }
    };

    getRoundedAmount = (amount, decimals) => {
        return formatHelper.formatFormulaDecimalNumber(amount, decimals);
    };

    getOriginalColorantsBySelectedUnit = () => {
        if (this.state.selectedUnit === settings.UNIT_G) {
            return this.props.params.formula.colorantListG;
        }

        if (this.state.selectedUnit === settings.UNIT_SHOT) {
            return this.props.params.formula.colorantListShot;
        }

        return this.props.params.formula.colorantList;
    };

    getColorantsBySelectedUnit = () => {
        if (this.state.selectedUnit === settings.UNIT_G) {
            return this.props.params.formula.modifiedColorantListG;
        }

        if (this.state.selectedUnit === settings.UNIT_SHOT) {
            return this.props.params.formula.modifiedColorantListShot;
        }

        return this.props.params.formula.modifiedColorantList;
    };

    getColorantFromSelectedList = (colorantId) => {
        let selectedColorant;
        for (selectedColorant of this.state.selectedColorants) {
            if (selectedColorant.id === colorantId) {
                return selectedColorant;
            }
        }

        return null;
    };

    findColorantInList = (list, colorantId) => {
        let colorant;
        for (colorant of list) {
            if (colorant.id === colorantId) {
                return colorant;
            }
        }

        return null;
    };

    scaleSelectedColorants = (scaling) => {
        let selectedColorants = [];

        let colorant = null;
        for (colorant of this.state.selectedColorants) {
            selectedColorants.push(colorant.updateAmount(this.state.originalAmounts[colorant.name] * scaling));
        }

        return selectedColorants;
    };

    getActiveColorantAmountFromSelected = (colorantId) => {
        let colorant = this.getColorantFromSelectedList(colorantId);

        if (colorant === null) {
            return 0;
        }

        return colorant.amount;
    };

    setNewScaling = (newScaling) => {
        if (this.state.modified) {
            this.setState({
                selectedColorants: this.scaleSelectedColorants(newScaling),
                scaling: newScaling,
                colorPreview: colorHelper.generateRgbByColorants(this.state.selectedColorantsForScaling, newScaling)
            });
        } else {
            this.setState({
                scaling: newScaling,
                colorPreview: colorHelper.generateRgbByScaling(this.state.originalColorPreview, newScaling)
            });
        }
    };

    resetOriginalAmounts = (selectedColorants) => {
        let originalAmounts = {};

        let colorant;
        for (colorant of selectedColorants) {
            originalAmounts[colorant.name] = colorant.amount;
        }

        return originalAmounts;
    };

    isFormulaModified = (colorants, scaling = 1) => {
        let originalColorants = this.getOriginalColorantsBySelectedUnit();

        if (originalColorants.length !== colorants.length) {
            return true;
        }

        let colorant, selectedColorant;
        for (colorant of originalColorants) {
            selectedColorant = this.findColorantInList(colorants, colorant.id);

            if (selectedColorant === null) {
                return true;
            }

            if (scaling === 1 && selectedColorant.amount !== colorant.amount) {
                return true;
            }

            if (this.getRoundedAmount(colorant.amount * scaling, config.FORMULA_DECIMALS) !== selectedColorant.amount) {
                return true;
            }
        }

        return false;
    };

    isColorantModified = (colorantId, amount) => {
        let originalColorants = this.getOriginalColorantsBySelectedUnit();

        let colorant;
        for (colorant of originalColorants) {
            if (colorant.id === colorantId) {
                return colorant.amount !== amount;
            }
        }

        return true;
    };

    isFormulaEdited = (colorants) => {
        let originalColorants = this.getOriginalColorantsBySelectedUnit();

        let colorant, selectedColorant;
        for (colorant of originalColorants) {
            selectedColorant = this.findColorantInList(colorants, colorant.id);

            if (selectedColorant === null || selectedColorant.amount !== colorant.amount) {
                return true;
            }
        }

        for (colorant of colorants) {
            if (this.findColorantInList(originalColorants, colorant.id) === null && colorant.amount !== 0) {
                return true;
            }
        }

        return false;
    };

    getColorantOriginalAmount = (colorantId) => {
        let originalColorants = this.getOriginalColorantsBySelectedUnit();

        let colorant;
        for (colorant of originalColorants) {
            if (colorant.id === colorantId) {
                return colorant.amount;
            }
        }

        return 0;
    };

    changeColorantValue = (id, value) => {
        let changedColorant = this.getColorantFromSelectedList(id);

        if (changedColorant === null) {
            return false;
        }

        const scaling = this.state.scaling;
        const modified = this.state.modified;

        let selectedColorants = this.state.selectedColorants.map((colorant) => {
            if (colorant.id !== id) {
                if (!modified && scaling !== 1) {
                    return colorant.updateAmount(
                        this.getRoundedAmount(colorant.amount * scaling, config.FORMULA_DECIMALS)
                    );
                }

                return colorant;
            }

            let originalAmount = this.getColorantOriginalAmount(colorant.id);

            if (scaling !== 1) {
                originalAmount = this.getRoundedAmount(originalAmount * scaling, config.FORMULA_DECIMALS);
            }

            if (originalAmount === 0 || value === 0) {
                return colorant.updateAmount(value);
            }

            let amountText = String(originalAmount);
            let amountDecimals = amountText.includes(".") ? amountText.split(".")[1].length : 0;

            amountText = String(value);
            let newAmountDecimals = amountText.includes(".") ? amountText.split(".")[1].length : 0;

            // Always edit amount if there is no more decimals outside of visible scope for original amount
            // F.e. original amount is 1.367 and FORMULA_DECIMALS is 5
            if (amountDecimals <= config.FORMULA_DECIMALS) {
                return colorant.updateAmount(value);
            }

            // New decimals are extending original decimals
            // F.e. original amount is 1.367999 and value 1.367999123 (FORMULA_DECIMALS = 5)
            if (amountDecimals < newAmountDecimals) {
                return colorant.updateAmount(value);
            }

            // New decimals are modified in visible decimal scope
            // F.e. original amount is 1.367999 and value 1.36 (FORMULA_DECIMALS = 5)
            if (newAmountDecimals < config.FORMULA_DECIMALS) {
                return colorant.updateAmount(value);
            }

            // New decimals are extending visible decimal scope, but decimals are equal to original decimals
            // F.e. original amount is 1.3679999999999 and value is 1.3679999 (FORMULA_DECIMALS = 5)
            if (this.getRoundedAmount(originalAmount, newAmountDecimals) === value) {
                return colorant.updateAmount(originalAmount);
            }

            // All the other use cases
            return colorant.updateAmount(value);
        });

        const isModified = this.isFormulaModified(selectedColorants, scaling);

        if (isModified) {
            let scaling = this.state.scaling;

            // This check prevents scaling from being reset after no change
            // between input focus and blur for already modified formula
            if (this.state.activeColorantAmount !== this.state.originalActiveColorantAmount) {
                scaling = 1;
            }

            this.setState({
                selectedColorants: selectedColorants,
                selectedColorantsForScaling: selectedColorants,
                originalAmounts: this.resetOriginalAmounts(selectedColorants),
                modified: true,
                scaling: scaling,
                colorPreview: this.getRgbPreviewForModifiedColorants(selectedColorants)
            });

            return true;
        }

        let resetOriginalAmounts = {};

        let resetSelectedColorants = this.getOriginalColorantsBySelectedUnit().map((colorant) => {
            let resetedColorant = colorant.clone();
            resetOriginalAmounts[colorant.name] = colorant.amount;
            return resetedColorant;
        });

        this.setState({
            selectedColorants: resetSelectedColorants,
            selectedColorantsForScaling: resetSelectedColorants,
            originalAmounts: resetOriginalAmounts,
            modified: false,
            colorPreview:
                scaling !== 1
                    ? colorHelper.generateRgbByColorants(resetSelectedColorants, scaling)
                    : this.state.originalPreview
        });

        return true;
    };

    getColorantFromList = (colorantId) => {
        let colorant;
        for (colorant of this.props.colorantList) {
            if (colorant.id + "-" + colorant.name === colorantId) {
                return colorant.clone();
            }
        }

        return null;
    };

    getColorantForCorrection = (colorants) => {
        let result = [];

        let colorant, originalColorant;
        for (colorant of colorants) {
            originalColorant = this.findColorantInList(this.getOriginalColorantsBySelectedUnit(), colorant.id);

            if (originalColorant === null) {
                result.push(colorant);
            } else {
                result.push(colorant.updateAmount(colorant.amount + originalColorant.amount));
            }
        }

        return result;
    };

    getColorantsForRgbPreview = (colorants) => {
        if (this.state.manualCorrection) {
            return this.getColorantForCorrection(colorants);
        }

        return colorants;
    };

    getRgbPreviewForModifiedColorants = (colorants) => {
        let modifiedColorants = this.getColorantsForRgbPreview(colorants);

        if (this.state.originalPreview === null || this.isFormulaEdited(modifiedColorants)) {
            return colorHelper.generateRgbByColorants(modifiedColorants);
        }

        return this.state.originalPreview;
    };

    handleCloseModalClick = () => {
        if (this.props.formula !== null && this.props.formula.isCorrection() && !this.props.formula.modified) {
            this.props.dispatchCloseActiveTab(
                this.props.tabId,
                this.props.tabList,
                this.props.dispensing ? this.props.tabId : null
            );
        }

        this.props.dispatchCloseModalAction();
    };

    handleSelectColorantClick = (event) => {
        let colorant = this.getColorantFromList(event.target.dataset.id);
        if (colorant !== null) {
            let selectedColorant = colorant.clone();
            if (this.state.selectedUnit === settings.UNIT_ML) {
                selectedColorant.amountType = settings.UNIT_ML;
            }

            if (this.state.selectedUnit === settings.UNIT_G) {
                selectedColorant.amountType = settings.UNIT_G;
            }

            if (this.state.selectedUnit === settings.UNIT_SHOT) {
                selectedColorant.amountType = this.props.shotsName;
            }

            let selectedColorants = [...this.state.selectedColorants, selectedColorant];

            this.setState({
                selectedColorants: selectedColorants,
                selectedColorantsForScaling: selectedColorants,
                originalAmounts: this.resetOriginalAmounts(selectedColorants),
                modified: this.isFormulaModified(selectedColorants),
                scaling: 1
            });
        }
    };

    getFilteredSelectedColorants = (id) => {
        return this.state.selectedColorants.filter((colorant) => colorant.id !== id);
    };

    handleRemoveColorantClick = (event) => {
        let colorant = this.getColorantFromSelectedList(Number(event.target.dataset.id));

        if (colorant !== null) {
            if (this.state.manualCorrection && this.getColorantOriginalAmount(colorant.id) > 0) {
                this.changeColorantValue(colorant.id, 0);
            } else {
                let selectedColorants = this.getFilteredSelectedColorants(colorant.id);

                this.setState({
                    selectedColorants: selectedColorants,
                    selectedColorantsForScaling: selectedColorants,
                    originalAmounts: this.resetOriginalAmounts(selectedColorants),
                    modified: this.isFormulaModified(selectedColorants),
                    scaling: 1,
                    colorPreview: this.getRgbPreviewForModifiedColorants(selectedColorants)
                });
            }
        }
    };

    handleColorantValueFocus = (event) => {
        event.target.select();

        let colorantId = Number(event.target.dataset.id);
        let amount = this.getActiveColorantAmountFromSelected(colorantId);
        let isModified = this.isColorantModified(colorantId, amount);

        if (!isModified && this.state.scaling !== 1) {
            amount = this.getRoundedAmount(amount * this.state.scaling, config.FORMULA_DECIMALS);
        }

        let activeColorantAmount = "0";

        if (
            isModified ||
            this.props.params === null ||
            this.props.params.formula === null ||
            this.props.params.formula.id === 0
        ) {
            activeColorantAmount = String(amount);
        } else {
            activeColorantAmount = String(this.getRoundedAmount(amount, config.FORMULA_DECIMALS));
        }

        this.setState({
            activeColorantRow: colorantId,
            activeColorantAmount: activeColorantAmount,
            originalActiveColorantAmount: activeColorantAmount
        });
    };

    handleColorantValueKeyDown = (event) => {
        if (event.keyCode === keyCodes.ENTER) {
            event.preventDefault();

            window.jQuery("#edit-colorant-" + this.state.activeColorantRow).blur();
        }
    };

    handleColorantValueChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                activeColorantAmount: validationHelper.formatDecimal(event.target.value)
            });
        }
    };

    handleColorantValueBlur = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.changeColorantValue(
                Number(event.target.dataset.id),
                Number(validationHelper.formatDecimal(event.target.value))
            );
        }

        this.setState({
            activeColorantRow: 0
        });
    };

    handleFormulaScalingFocus = (event) => {
        event.target.select();
    };

    handleFormulaScalingSliderChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value) && this.state.activeColorantRow === 0) {
            this.setNewScaling(Math.round(Number(event.target.value) * 100) / 100);
        }
    };

    getValidScalingFormat = (targetValue) => {
        if (isNaN(targetValue)) {
            return 1;
        }

        let value = Number(targetValue);

        if (value < 1) {
            return 0.01;
        }

        if (value > 200) {
            return 2;
        }

        return Math.round(value) / 100;
    };

    getValidScalingFormatOnChange = (targetValue) => {
        if (targetValue === "") {
            return 0;
        }

        return this.getValidScalingFormat(targetValue);
    };

    getValidScalingFormatOnBlur = (targetValue) => {
        if (targetValue === "") {
            return 1;
        }

        return this.getValidScalingFormat(targetValue);
    };

    handleFormulaScalingChange = (event) => {
        this.setNewScaling(this.getValidScalingFormatOnChange(event.target.value));
    };

    handleFormulaScalingBlur = (event) => {
        this.setNewScaling(this.getValidScalingFormatOnBlur(event.target.value));
    };

    handleEditColorantsClick = () => {
        if (this.props.generateColorPreview) {
            this.props.dispatchEditFormulaRgbAction(this.props.tabId, this.state.colorPreview);
        }

        // In case of manual correction, selected colorants contain corrections in their amount values
        if (this.state.manualCorrection) {
            // Calculates amount from original amount (originalColorant.amount) and correction (editedColorant.amount)
            let correction = this.getColorantForCorrection(this.state.selectedColorants);

            this.props.dispatchEditColorantsAction(
                this.props.tabId,
                correction,
                this.state.selectedUnit,
                this.isFormulaModified(correction),
                1,
                this.props.shotsCoef,
                this.props.shotsName
            );
        } else {
            this.props.dispatchEditColorantsAction(
                this.props.tabId,
                this.state.selectedColorants,
                this.state.selectedUnit,
                this.state.modified,
                this.state.modified ? 1 : this.state.scaling,
                this.props.shotsCoef,
                this.props.shotsName
            );
        }

        this.props.dispatchCloseModalAction();
    };

    handleUnitChange = (event) => {
        let originalAmounts = modelHelper.clone(this.state.originalAmounts);
        let newColorants = this.state.selectedColorants.map((colorant) => {
            let amount = conversionHelper.convertAmountByColorant(
                colorant,
                this.state.selectedUnit,
                event.target.value,
                this.props.shotsCoef
            );

            let newColorant = colorant.updateAmountValues(
                amount,
                event.target.value === settings.UNIT_SHOT ? this.props.shotsName : event.target.value
            );
            originalAmounts[colorant.name] = amount;
            return newColorant;
        });

        this.setState({
            selectedColorants: newColorants,
            selectedColorantsForScaling: newColorants,
            originalAmounts: originalAmounts,
            selectedUnit: event.target.value
        });
    };

    handleMinusScalingClick = () => {
        if (this.state.scaling >= 0.1) {
            this.setNewScaling(Math.round((this.state.scaling - 0.05) * 100) / 100);
        }
    };

    handlePlusScalingClick = () => {
        if (this.state.scaling <= 1.95) {
            this.setNewScaling(Math.round((this.state.scaling + 0.05) * 100) / 100);
        }
    };

    getCanisterByColorant = (colorant) => {
        let canister;
        for (canister of this.props.canisterList) {
            if (canister.colorant !== null && canister.colorant.name === colorant.name) {
                return canister;
            }
        }

        return null;
    };

    getCanisterRgb = (canister, colorant) => {
        if (canister !== null && canister.colorant !== null && canister.colorant.rgb !== null) {
            return canister.colorant.rgb;
        }

        return colorant.rgb;
    };

    getActiveColorantAmount = (selectedColorant) => {
        if (this.state.modified) {
            if (selectedColorant.id === this.state.activeColorantRow) {
                return this.state.activeColorantAmount;
            }

            return formatHelper.formatDecimal(selectedColorant.amount);
        }

        if (selectedColorant.id === this.state.activeColorantRow) {
            return this.state.activeColorantAmount;
        }
        return formatHelper.formatDecimal(
            this.state.scaling === 0 ? selectedColorant.amount : selectedColorant.amount * this.state.scaling
        );
    };

    getColorantValidationWarning = (colorantId) => {
        if (this.props.validation === null || !this.props.validation.hasErrorByColorant(colorantId)) {
            return null;
        }

        return (
            <ReactSVG
                src={imgWarning}
                className="img-warning height-3vh fit-image"
                alt="warning"
                data-text={translationHelper.getFormulaErrorTranslations(
                    this.props.validation.getErrorsByColorant(colorantId)
                )}
                onMouseEnter={tooltipHelper.createTooltip}
            />
        );
    };

    getOriginalAmountLabel = (amount, amountType) => {
        if (!this.state.manualCorrection) {
            return null;
        }

        return (
            <div className="col-2 flex font-size-1em margin-right-10 flex-end">
                <span>
                    {formatHelper.formatDecimal(amount)} {amountType}
                </span>
                <ReactSVG
                    className="svg padding-left-10 flex-align-center font-size-1em"
                    src={imgPlus}
                    style={{height: "0.75em"}}
                    wrapper="span"
                />
            </div>
        );
    };

    getRemoveButton = (colorant, originalAmount) => {
        if (this.state.manualCorrection && originalAmount > 0 && colorant.amount === 0) {
            return <div className="col-1 flex flex-end height-100per padding-top-5 padding-bottom-5" />;
        }

        return (
            <div className="col-1 flex flex-end height-100per padding-top-5 padding-bottom-5">
                <Button
                    className="svg-only-btn"
                    elementProps={{
                        "data-id": colorant.id
                    }}
                    svgBefore={imgDelete}
                    onClick={this.handleRemoveColorantClick}
                />
            </div>
        );
    };

    getSelectedColorantRows = () => {
        let canister, rgb, originalAmount;
        let nameClass = "col-6";
        let inputClass = "col-4";

        if (this.state.manualCorrection) {
            nameClass = "col-5";
            inputClass = "col-3";
        }

        return this.state.selectedColorants.map((selectedColorant) => {
            canister = this.getCanisterByColorant(selectedColorant);
            rgb = this.getCanisterRgb(canister, selectedColorant);
            originalAmount = this.getColorantOriginalAmount(selectedColorant.id);

            return (
                <div
                    key={selectedColorant.id}
                    className="width-100per flex font-size-1_75em std-border-bottom flex-align-center"
                >
                    <div
                        className={
                            nameClass +
                            " color-primary font-size-1_25em flex flex-align-center-vertical padding-top-5 padding-bottom-5"
                        }
                    >
                        <div className="color-square" style={{backgroundColor: rgb, height: "25px", width: "25px"}} />
                        <div>{selectedColorant.displayName}</div>
                    </div>
                    <div className="col-1 flex flex-align-center">
                        {this.getColorantValidationWarning(selectedColorant.id)}
                    </div>
                    {this.getOriginalAmountLabel(originalAmount, selectedColorant.amountType)}
                    <div className={inputClass + " flex flex-align-center-vertical flex-gap-10px"}>
                        <NumericKeyboardInput
                            id={"edit-colorant-" + selectedColorant.id}
                            type="text"
                            className="text-right flex-child numeric-keyboard-input primary-input"
                            value={this.getActiveColorantAmount(selectedColorant)}
                            data-id={selectedColorant.id}
                            onFocus={this.handleColorantValueFocus}
                            onBlur={this.handleColorantValueBlur}
                            onChange={this.handleColorantValueChange}
                            onKeyDown={this.handleColorantValueKeyDown}
                            extended={true}
                            setInputState={this.setColorantValueState}
                        />
                        {selectedColorant.amountType}
                    </div>
                    {this.getRemoveButton(selectedColorant, originalAmount)}
                </div>
            );
        });
    };

    areSelectedColorantsAmountValid = () => {
        if (this.state.manualCorrection) {
            return true;
        }

        let colorant;
        for (colorant of this.state.selectedColorants) {
            if (colorant.id === this.state.activeColorantRow) {
                if (this.state.activeColorantAmount <= 0) {
                    return false;
                }
            } else if (colorant.amount <= 0) {
                return false;
            }
        }

        return true;
    };

    getUnitsSelectBox = () => {
        let units = [];

        if (this.props.visibleUnits.ml || this.props.unit === settings.UNIT_ML) {
            units.push(
                <option key={settings.UNIT_ML} value={settings.UNIT_ML}>
                    {settings.UNIT_ML}
                </option>
            );
        }

        if (this.props.visibleUnits.g || this.props.unit === settings.UNIT_G) {
            units.push(
                <option key={settings.UNIT_G} value={settings.UNIT_G}>
                    {settings.UNIT_G}
                </option>
            );
        }

        if (this.props.visibleUnits.shots || this.props.unit === settings.UNIT_SHOT) {
            units.push(
                <option key={settings.UNIT_SHOT} value={settings.UNIT_SHOT}>
                    {this.props.shotsName}
                </option>
            );
        }

        if (units.length > 1) {
            return (
                <div className=" flex flex-wrap flex-align-center-vertical">
                    <Translate className="color-primary" value="modal.changeColorantUnit" />
                    <select
                        className="min-width-150 primary-select margin-left-5"
                        value={this.state.selectedUnit}
                        onChange={this.handleUnitChange}
                    >
                        {units}
                    </select>
                </div>
            );
        }

        return "";
    };

    getOkButton = () => {
        return (
            <Button
                label={<Translate value="general.confirm" />}
                svgBefore={imgConfirm}
                onClick={this.handleEditColorantsClick}
                tooltipText={this.areSelectedColorantsAmountValid() ? null : translate("mainTab.colorantsAreInvalid")}
                disabled={!this.areSelectedColorantsAmountValid()}
            />
        );
    };

    getScalingSlider = () => {
        if (this.state.manualCorrection) {
            return "";
        }

        return (
            <div className="col-12 flex flex-align-center-vertical padding-bottom-5 padding-top-5">
                <div className="flex flex-align-center-vertical margin-right-10">
                    <Input
                        className="width-60px primary-input margin-right-5 text-align-center"
                        type="text"
                        value={this.state.scaling === 0 ? "" : Math.round(this.state.scaling * 100)}
                        disabled={this.state.selectedColorants.length === 0}
                        elementProps={{
                            style: {textAlign: "center"},
                            onFocus: this.handleFormulaScalingFocus,
                            onChange: this.handleFormulaScalingChange,
                            onBlur: this.handleFormulaScalingBlur
                        }}
                    />
                    %
                </div>
                <Button
                    label={"-"}
                    onClick={this.handleMinusScalingClick}
                    disabled={this.state.selectedColorants.length === 0}
                />
                <Input
                    className="margin-left-5 margin-right-5 fill-flex-space primary-input"
                    type="range"
                    value={this.state.scaling === 0 ? 1 : this.state.scaling}
                    onChange={this.handleFormulaScalingSliderChange}
                    disabled={this.state.selectedColorants.length === 0}
                    elementProps={{
                        min: "0.05",
                        max: "2",
                        step: "0.05"
                    }}
                />
                <Button
                    label={"+"}
                    onClick={this.handlePlusScalingClick}
                    disabled={this.state.selectedColorants.length === 0}
                />
            </div>
        );
    };

    getColorantBoxes = (height) => {
        if (!this.props.colorantListInit) {
            return (
                <div className="height-50per general-wrapper">
                    <div className="general-wrapper-body general-colorant-select-box-wrapper flex-align-center">
                        <img alt="loading" src={imgLoader} />
                    </div>
                </div>
            );
        }

        return (
            <ColorantBoxes
                elementProps={{style: {height: height}}}
                loggedUser={this.props.loggedUser}
                activeDatabase={null}
                selectedColorants={this.state.selectedColorants}
                allowCanisterColorants={false}
                canisterList={this.props.canisterList}
                colorantList={this.props.colorantList}
                databaseColorantList={null}
                sorting={null}
                spaceInPackage={this.props.package !== null ? this.props.package.package : null}
                handleSelectColorantClick={this.handleSelectColorantClick}
            />
        );
    };

    getHeader = () => {
        if (this.state.manualCorrection) {
            return modelHelper.buildModalSection(<Translate value="matching.manualColorCorrection" />);
        }

        return modelHelper.buildModalSection(<Translate value="general.colorants" />);
    };

    getContent = () => {
        if (this.props.generateColorPreview) {
            return modelHelper.buildModalSection(
                <React.Fragment>
                    <div className="col-8 height-100per">
                        <div className="height-50per flex flex-column slim-scroll">
                            {this.getSelectedColorantRows()}
                        </div>
                        {this.getScalingSlider()}
                        {this.getColorantBoxes("40%")}
                    </div>
                    <div className="col-4 height-100per flex flex-wrap padding-left-15 slim-scroll">
                        <div className="col-12 flex text-align-center">
                            <div className="col-6 color-primary">
                                <Translate value="mainTab.originalColor" />
                            </div>
                            <div className="col-6 color-primary">
                                <Translate value="mainTab.newColorAfterScaling" />
                            </div>
                        </div>
                        <div className="col-12 flex" style={{height: "75%"}}>
                            <CompareColorsSquare colors={[this.state.originalColorPreview, this.state.colorPreview]} />
                        </div>
                        <div className="warning-message margin-5 padding-left-10 padding-right-10">
                            <Translate value="mainTab.newRgbNotAccuratelyMeasured" />
                        </div>
                    </div>
                </React.Fragment>,
                "flex flex-wrap flex-column height-100per"
            );
        }

        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="height-50per flex flex-column slim-scroll">{this.getSelectedColorantRows()}</div>
                {this.getScalingSlider()}
                {this.getColorantBoxes("35%")}
            </React.Fragment>,
            "flex flex-column height-100per"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="flex margin-right-auto flex-gap-10px flex-align-center-vertical">
                    {this.getUnitsSelectBox()}
                </div>
                <div className="flex margin-left-auto flex-wrap flex-gap-10px flex-align-center-vertical">
                    {this.getOkButton()}
                    <CancelButton onClick={this.handleCloseModalClick} />
                </div>
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                className={this.state.localData ? "custom-formula" : ""}
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={this.getHeader()}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{width: "70%", height: "80%"}}
            />
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    if (store.formula[ownProps.tabId] === undefined) {
        return {
            loggedUser: store.login.loggedUser,
            product: null,
            color: null,
            base: null,
            formula: null,
            package: null,
            validation: null,
            colorantListInit: false,
            colorantList: [],
            canisterList: store.rcc.canisterList,
            visibleUnits: store.settings.visibleUnits,
            lastUsedUnit: store.settings.lastUsedUnit,
            shotsCoef: store.settings.shotsCoef,
            shotsName: store.settings.shotsName,
            generateColorPreview: store.settings.generateColorPreview,
            tabList: store.navigation.tabList,
            dispensing: false
        };
    }

    let colorantList = store.global.colorantList;

    if (store.formula[ownProps.tabId].colorantList !== null) {
        colorantList = store.formula[ownProps.tabId].colorantList;
    }

    return {
        loggedUser: store.login.loggedUser,
        product: store.formula[ownProps.tabId].product,
        color: store.formula[ownProps.tabId].color,
        base: store.formula[ownProps.tabId].base,
        formula: store.formula[ownProps.tabId].formula,
        package: store.formula[ownProps.tabId].package,
        validation: store.formula[ownProps.tabId].validation,
        colorantListInit:
            store.formula[ownProps.tabId].colorantList !== null || store.formula[ownProps.tabId].base === null,
        colorantList: colorantList,
        canisterList: store.rcc.canisterList,
        visibleUnits: store.settings.visibleUnits,
        lastUsedUnit: store.settings.lastUsedUnit,
        shotsCoef: store.settings.shotsCoef,
        shotsName: store.settings.shotsName,
        generateColorPreview: store.settings.generateColorPreview,
        tabList: store.navigation.tabList,
        dispensing: store.formula[ownProps.tabId].dispensing
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.EDIT_COLORANTS_MODAL));
        },
        dispatchCloseActiveTab: (tabId, tabList, dispensingTabId) => {
            dispatch(navigationActions.closeActiveTab(tabId, tabList, dispensingTabId));
        },
        dispatchEditColorantsAction: (tabId, colorantList, unit, modified, scaling, shotsCoef, shotsName) => {
            dispatch(formulaActions.editColorants(tabId, colorantList, unit, modified, scaling, shotsCoef, shotsName));
        },
        dispatchEditFormulaRgbAction: (tabId, rgb) => {
            dispatch(customTabActions.editFormulaRgb(tabId, rgb));
        },
        dispatchGetAllColorantsForBipAction: (tabId, baseId, productId) => {
            dispatch(formulaActions.getAllColorantsForBip(tabId, baseId, productId));
        }
    };
};

export default EditColorantsModal = connect(mapStoreToProps, mapDispatchToProps)(EditColorantsModal);
